import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { StyleTypeDropdown } from './index.style';

const MobilePackageTypes = ({ types, activeType, onChangeType }) => {
  const { t } = useTranslation();

  return (
    <StyleTypeDropdown>
      <FormControl fullWidth>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={activeType}
          onChange={(e) => onChangeType(e.target.value)}
          sx={{
            boxShadow: 'none',
            '.MuiOutlinedInput-notchedOutline': { border: 0 },
            borderRadius: '8px',
            backgroundColor: 'white',
          }}
        >
          {types.map((type) => (
            <MenuItem
              className="menu-item-container"
              key={type}
              value={type.id}
              sx={{
                display: 'flex',
                gap: '8px',
                color: `${COLOR.darkBlue}`,
              }}
            >
              <img
                style={{ width: '24px', height: '24px' }}
                src={type.logo}
                alt={type.label}
              />
              <Typography
                sx={{
                  color: `${COLOR.darkBlue}`,
                  fontSize: '14px',
                  fontWeight: '700',
                }}
              >
                {t(type.label)}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StyleTypeDropdown>
  );
};

export default MobilePackageTypes;
